import { render, staticRenderFns } from "./SurveyLanding.vue?vue&type=template&id=e8db947c&scoped=true&"
import script from "./SurveyLanding.vue?vue&type=script&lang=js&"
export * from "./SurveyLanding.vue?vue&type=script&lang=js&"
import style0 from "./SurveyLanding.vue?vue&type=style&index=0&id=e8db947c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8db947c",
  null
  
)

export default component.exports